import { CategoryType } from "~/models/category"

export default {
	// general
	HomeUrl: () => "/",
	SearchUrl: () => "/search",
	PrivacyPolicyUrl: () => `/privacy-policy`,
	TermsOfServiceUrl: () => `/terms-of-service`,
	// auth
	AuthStartUrl: () => "/auth/start",
	LoginUrl: () => "/auth",
	//
	DiscoverUrl: () => "/discover",
	NotificationsUrl: (businessId?: number) =>
		businessId ? `/businesses/${businessId}/notifications` : `/notifications`,
	ShareUrl: () => "/share",
	HelpUrl: () => "/help",
	// shop
	ShopUrl: () => "/shop",
	YourListingsUrl: () => "/shop/your-listings",
	ViewShopItemUrl: (postId: number) => `/shop/${postId}`,
	SearchShopUrl: () => `/shop/search`,
	// users
	SettingsUrl: () => `/settings`,
	ProfileUrl: (userId?: number) => (userId ? `/users/${userId}` : "/users/profile"),
	ProfileConnectionsUrl: () => "/users/profile/connections",
	ProfileBlockedUsersUrl: () => "/users/profile/blocked-users",
	ProfileFavedBusinessesUrl: () => "/users/profile/faved-businesses",
	ProfileLikedPostsUrl: () => "/users/profile/liked-posts",
	ProfileEventsUrl: () => "/users/profile/events",
	EditProfileUrl: () => "/users/edit-profile",
	ProfileChangePasswordUrl: () => "/users/change-password",
	EditPrivacySettingsUrl: () => "/users/edit-privacy-settings",
	WaitingForRemovalUrl: () => "/users/waiting-for-removal",
	// posts
	ViewPostUrl: (postId: number) => `/posts/${postId}`,
	ViewPostAttendeesUrl: (postId: number) => `/posts/${postId}/attendees`,
	AddPostUrl: (businessId?: number) => (businessId ? `/businesses/${businessId}/posts/add` : "/posts/add"),
	EditPostUrl: (postId: number, businessId?: number) =>
		businessId ? `/businesses/${businessId}/posts/edit-${postId}` : `/posts/edit-${postId}`,
	// businesses
	AddBusinessUrl: () => `/businesses/add`,
	EditBusinessUrl: (id: number) => `/businesses/${id}/edit`,
	BusinessUrl: (id: number) => `/businesses/${id}`,
	BusinessPageUrl: (id: number) => `/businesses/${id}/page`,
	BusinessAdsUrl: (id: number) => `/businesses/${id}/ads`,
	BusinessAddAdUrl: (id: number) => `/businesses/${id}/ads/add`,
	BusinessPostsUrl: (id: number) => `/businesses/${id}/posts`,
	// direct messages
	DirectMessagesUrl: (businessId?: number) =>
		businessId ? `/businesses/${businessId}/direct-messages` : `/direct-messages`,
	SendDirectMessageUrl: (businessId?: number) =>
		businessId ? `/businesses/${businessId}/direct-messages/send` : `/direct-messages/send`,
	UserDirectMessagesUrl: (userId: number, businessId?: number) =>
		businessId ? `/businesses/${businessId}/direct-messages/${userId}` : `/direct-messages/${userId}`,
	// demo
	DemoUrl: () => "/demo",
	// admin
	AdminLoginUrl: () => "/admin/login",
	AdminDashboardUrl: () => "/admin",
	// admin users
	ManageUsersUrl: () => `/admin/users`,
	ManageUsersPageUrl: (page: number) => `/admin/users/page/${page}`,
	// admin logs
	ManageLogsUrl: () => `/admin/logs`,
	ManageLogsPageUrl: (page: number) => `/admin/logs/page/${page}`,
	// admin rules
	ManageRulesUrl: () => `/admin/rules`,
	// admin about us
	ManageAboutUsUrl: () => `/admin/about-us`,
	// admin contact us
	ManageContactUsUrl: () => `/admin/contact-us`,
	// admin metas
	ManageMetasUrl: () => `/admin/metas`,
	// admin slides
	ManageSlidesUrl: () => `/admin/slides`,
	// admin reports
	ManageReportsUrl: () => `/admin/reports`,
	// admin categories
	ManageCategoriesUrl: () => `/admin/categories`,
	// admin dev tickets
	ManageDevTicketUrl: (id: number) => `/admin/dev-tickets/${id}`,
	ManageDevTicketsUrl: () => `/admin/dev-tickets`,
	ManageDevTicketsPageUrl: (page: number) => `/admin/dev-tickets/page/${page}`,
	// admin posts
	ManagePostsUrl: (type: CategoryType) => `/admin/posts?type=${type}`,
	ManagePostsPageUrl: (type: CategoryType, page: any) => `/admin/posts/page/${page}?type=${type}`,
	AdminCreatePostUrl: (type: CategoryType) => `/admin/posts/create?type=${type}`,
	AdminEditPostUrl: (id: any) => `/admin/posts/${id}`
}
